import { colors } from '../../../../../utils/colors'

export const jobComponentStyles = {
  error: { color: colors.red },
}
